import { render, staticRenderFns } from "./CompanyCoverages.vue?vue&type=template&id=0bd252f3&scoped=true&"
import script from "./CompanyCoverages.vue?vue&type=script&lang=js&"
export * from "./CompanyCoverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd252f3",
  null
  
)

export default component.exports